import { useEffect } from "react";
import { Input, Form } from "antd";
import { StudentType } from "@/containers/humanResourceManagement/studentManagement/types";
import { TranscriptScoreType } from './types';

interface Props {
  form: any;
  info: StudentType;
  transcriptScoreArray: TranscriptScoreType['students'];
}

function ModalIndividualScoring(props: Props) {
  const { form, info, transcriptScoreArray } = props;

  useEffect(() => {
    transcriptScoreArray.forEach((item) => {
      const { subjectId } = item;
      form.setFieldsValue({ [subjectId]: info[subjectId] });
    })
  }, [form, info, transcriptScoreArray]);

  return (
    <Form
      className="admin-form"
      style={{ marginTop: 20 }}
      labelCol={{ lg: { span: 8 }, xs: { span: 24 }, sm: { span: 8 } }}
      wrapperCol={{ lg: { span: 16 }, xs: { span: 24 }, sm: { span: 16 } }}
      form={form}
    >
      {transcriptScoreArray.map((item) => (
        <Form.Item
          label={item.subjectEnName}
          name={item.subjectId}
          key={item.subjectId}
        >
          <Input />
        </Form.Item>
      ))}
    </Form >
  );
}

export default ModalIndividualScoring;